import { Github, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import NS from "../assets/NS_Logo.png";
import { useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();

  return (
    <footer className="relative border-t border-slate-800 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Social Section */}
          <div>
            <div className="flex-column align-items-center items-center space-x-2 mb-6">
              <img src={NS} width="175px" alt="NeuroStudio Logo" />
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Empowering businesses with intelligent AI solutions that transform operations and drive growth.
            </p>
          </div>

          {/* Products Section */}
          <div>
            <h4 className="text-white font-bold mb-6">Products</h4>
            <ul className="space-y-3">
              <li><a href="/#services" className="text-slate-400 hover:text-white transition-colors">AI Employees</a></li>
              <li><a href="/#services" className="text-slate-400 hover:text-white transition-colors">Chatbots</a></li>
              <li><a href="/#services" className="text-slate-400 hover:text-white transition-colors">Backend Automation</a></li>
              <li><a href="/#services" className="text-slate-400 hover:text-white transition-colors">Web &amp; App Design</a></li>
            </ul>
          </div>

          {/* Empty spacer for grid balance */}
          <div className="hidden lg:block"></div>

          {/* Contact/Support Section - At the margin end */}
          <div>
            <h4 className="text-white font-bold mb-6">Company</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">About Us</Link>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:hello@byo.ai" className="text-slate-400 hover:text-white transition-colors">
                  Support@NeuroStudio.io
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <a href="tel:5129619439" className="text-slate-400 hover:text-white transition-colors">
                  (737) 252-9843
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400">
                  Austin, Texas
                </span>
              </li>
            </ul>
            {location.pathname !== "/about" ?
              <div className="mt-6">
                <a href="#cta" className="text-blue-400 hover:text-blue-300 transition-colors font-semibold">
                  Get Help →
                </a>
              </div>
              : ""}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-slate-400 text-sm">
            © 2025 NeuroStudio. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="#" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="text-slate-400 hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="text-slate-400 hover:text-white transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}